import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { eventMessageActions } from '@Store/slices/eventMessageSlice';
import { useAppDispatch } from '.';

interface ReturnValue {
  handleBackToListRequests: () => void;
}

const useNavigationToListRequests = (): ReturnValue => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleBackToListRequests = useCallback((): void => {
    navigate('.', { replace: true, state: { redirected: true } });
    navigate(-1);
    dispatch(eventMessageActions.sendEventType('REFETCH'));
  }, []);

  return { handleBackToListRequests };
};

export default useNavigationToListRequests;
